import Vue from 'vue/dist/vue.esm';
import VueTinySlider from 'vue-tiny-slider';
// import EventBus from './js/EventBus';
import SitePlugin from "./js/SitePlugin";

Vue.use(SitePlugin);

const files = require.context('./js/components/', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('tiny-slider', VueTinySlider);

new Vue({
  el: '#accvent-app',
  data() {
    return {
      menuIsOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
    //  TODO Disable body scroll
    }
  }
});
